export const offerDataFrag = `
    id
    code
    name
    color
    unit
`;
